import { ProductType } from 'src/home_page/components/ProductPop/ProductPop'

export const gourmetFoodsExpandData: ProductType = {
  type: 'product',
  title: 'Gourmet Foods',
  description:
    'Nothing pairs more perfectly with a heartfelt message than a delectable treat. Our gourmet foods are mouth-watering, eye-popping, palate pleasers sure to impress your clients, friends, family, and neighbors. Our variety of gourmet foods are packaged perfectly and professionally. You’re sure to make an impression no matter which one you choose! ',
  categoryId: '80',
}
